/**
 * Floating labels for input text
 */

let floatingLabel = {
    notEmptyClass: 'floating-label__control--not-empty',

    init: function() {
        Array.from(document.querySelectorAll('.floating-label__control'), el => {
            this.initControl(el);
        });
    },

    initControl: function(el) {
        el.addEventListener('change', e => {
            this.checkEmptyControl(e.target);
        });

        el.addEventListener('blur', e => {
            window.setTimeout(() => {
                this.checkEmptyControl(e.target);
            }, 100);
        });

        this.checkEmptyControl(el);
    },

    checkEmptyControl: function(el) {
        if (el.value !== '') {
            el.classList.add(this.notEmptyClass);
        } else {
            el.classList.remove(this.notEmptyClass);
        }
    }

};

export default floatingLabel;


// WEBPACK FOOTER //
// ./src/js/components/floating-label.js